<template>
  <div styleName="courseware_canvas_layer" ref="canvasWrap">
    <canvas id="canvas" :width="pptSize.width" :height="pptSize.height"></canvas>
  </div>
</template>

<script>
import styles from './index.scss'
import cssModules from 'vue-css-modules'
import { mapGetters, mapMutations } from 'vuex'
import { signalSdk } from '../../utils/getSDK'
import EleResize from '../../utils/divResize'

class Draw {
  constructor (props) {
    this.canvas = document.getElementById('canvas')
    this.ctx = this.canvas.getContext('2d')
    let defaultOptions = {
      userRole: 1, // 1为老师 3为助教
      type: 1, // 1静态课件 2动态课件
      paintColor: '#FF0000',
      paintStyle: 'round',
      paintWidth: 2 // 标准画笔宽度
    }
    // 返回canvas画布矩形对象，包含四个属性：left、top、right和bottom,分别表示元素各边与页面上边和左边的距离
    this.stageInfo = this.canvas.getBoundingClientRect()
    this.options = Object.assign({}, defaultOptions, props)
    this.pathArr = [] // 记录划线路径的数组
  }

  init () {
    this.initParams()
    if (this.options.userRole === 1) this.initEvent() // 老师可以划线
  }

  resizeCanvas () {
    this.stageInfo = this.canvas.getBoundingClientRect()
    if (this._teaArr.length > 0) {
      this.draw(this._teaArr)
    }
    if (this._assistTeaArr.length > 0) {
      this.draw(this._assistTeaArr)
    }
  }

  initParams () {
    this._teaArr = [] // 存储老师划线数据
    this._assistTeaArr = [] // 存储助理教师划线数据
    this._painting = false // 当前是否处于绘画状态
  }

  initEvent () {
    this.canvas.onmousedown = (e) => {
      this.options.startDrawCallback && this.options.startDrawCallback()
      this.drawBegin(e)
    }
    this.canvas.onmouseup = () => {
      this.drawEnd()
    }
  }

  drawBegin (e) {
    window.getSelection() ? window.getSelection().removeAllRanges() : document.selection.empty()
    // 开始新的路径，清除以前的路径
    this._painting = !this._painting
    this.ctx.beginPath()
    // 描边样式
    this.ctx.strokeStyle = this.options.paintColor
    this.ctx.lineJoin = this.options.paintStyle
    this.ctx.lineWidth = parseInt(this.options.paintWidth * this.canvas.width / this.options.width)
    let startX = e.clientX - this.stageInfo.left
    let startY = e.clientY - this.stageInfo.top
    // 指定绘图起点
    this.ctx.moveTo(startX, startY)
    this.pathArr.push(startX, startY)
    document.onmousemove = (e) => {
      if (this._painting) this.drawing(e)
    }
  }

  drawing (e) {
    let startX = e.clientX - this.stageInfo.left
    let startY = e.clientY - this.stageInfo.top
    this.ctx.lineTo(startX, startY)
    // 根据路径绘制路线
    this.ctx.stroke()
    // 记录终点坐标
    this.pathArr.push(startX, startY)
  }

  drawEnd () {
    this._painting = !this._painting
    this.ctx.closePath()
    let newArr = this.pathArr.map((item, index) => {
      return parseInt(item * this.options.width / this.canvas.width)
    })
    this.pathArr = [] // 将上次的划线坐标数组清空，否则会造成连线
    if (signalSdk && signalSdk.sendDrawLine) {
      console.log('send ppt drawline')
      signalSdk.sendDrawLine({
        color: '',
        content: newArr.join()
      })
    }
    this._teaArr.push({ content: newArr.join() })
    document.onmousedown = null
    document.onmouseup = null
    document.onmousemove = null
  }

  sendDrawLine (color, content) {
    this._assistTeaArr.push({ content })
    this.draw(this._assistTeaArr)
  }

  // 助教端划线
  draw (data) {
    let startX
    let startY
    let moveX
    let moveY
    let pathArr
    let scaleX
    let scaleY
    let canvas = this.canvas
    let ctx = this.ctx
    scaleX = canvas.width / this.options.width
    scaleY = canvas.height / this.options.height
    ctx.scale(scaleX, scaleY)
    ctx.strokeStyle = this.options.paintColor
    ctx.lineJoin = this.options.paintStyle
    ctx.lineWidth = this.options.paintWidth
    ctx.beginPath()
    data.forEach((item, index) => {
      pathArr = item.content.split(',')
      startX = parseInt(pathArr[0])
      startY = parseInt(pathArr[1])
      ctx.moveTo(startX, startY)
      for (let i = 2; i < pathArr.length - 1; i++) {
        if (i % 2 === 0) {
          moveX = JSON.parse(pathArr[i])
          moveY = JSON.parse(pathArr[i + 1])
        }
        ctx.lineTo(moveX, moveY)
      }
    })
    ctx.stroke()
    ctx.closePath()
    ctx.scale(this.options.width / canvas.width, this.options.height / canvas.height)
  }

  clearCanvas () {
    if (this.options.userRole === 1) {
      this._teaArr = []
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      if (signalSdk && signalSdk.sendClear) { // 老师发送清屏信令
        console.log('send clear screen')
        signalSdk.sendClear()
      }
    } else {
      this._assistTeaArr = []
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
    }
  }
}

export default {
  mixins: [cssModules(styles)],
  data () {
    return {
      drawInstance: null
    }
  },
  computed: {
    ...mapGetters(['roomDetail', 'clearscreen', 'pptSize']),
    canvasWrap () {
      return this.$refs.canvasWrap
    }
  },
  watch: {
    clearscreen (newFlag) {
      if (newFlag) this.drawInstance.clearCanvas()
    }
  },
  mounted () {
    this.initCanvas()
    this.initSDKListen()
    this.addAllListeners()
  },
  beforeDestroy () {
    // this.removeAllListeners()
  },
  methods: {
    ...mapMutations({
      clearScreen: 'CLEAR_SCREEN'
    }),
    addAllListeners () {
      EleResize.on(this.canvasWrap, this.resizeCanvas)
    },
    removeAllListeners () {
      EleResize.off(this.canvasWrap, this.resizeCanvas)
    },
    initCanvas () {
      let $t = setTimeout(() => { // 等待canvas宽高设置完成后再初始化
        this.drawInstance = new Draw({
          width: 640, // 标准课件宽度
          height: 480, // 标砖课件高度
          userRole: this.roomDetail.data.roomRole,
          startDrawCallback: this.clear
        })
        this.drawInstance.init() // 老师可以使用画笔
        clearTimeout($t)
      }, 500)
    },
    resizeCanvas () {
      this.drawInstance.resizeCanvas()
    },
    clear () {
      this.clearScreen(false)
    },
    initSDKListen () {
      let self = this
      // 监听到划线信息
      signalSdk.on('BOARD_PPT_DRAW_LINE', function (data) {
        console.log('receive ppt drawline')
        self.clearScreen(false)
        let { color, content } = data
        self.drawInstance.sendDrawLine(color, content)
      })
      // 监听到清屏信息
      signalSdk.on('BOARD_PPT_CLEAR', function (data) {
        console.log('receive clear screen')
        self.clearScreen(true)
      })
    }
  }
}
</script>
